export default "__VITE_ASSET__c5e1851b__"